import React from 'react'
import { Badge } from 'antd'
import config from 'config.json'
import './ProviderSearchLink.css'

const ProviderSearchLink = ({ title, image, onClick }) => {
  return (
    <Badge className='provider-search-link' data-name={title} onClick={onClick}>
      <div className='provider-search-link-container'>
        {image && (
          <img
            src={config.gcpStorageUrl + '/app/' + image.toLowerCase() + '.svg'}
            className='provider-search-link-image'
          />
        )}
        <div className='provider-search-link-title'>{title}</div>
      </div>
    </Badge>
  )
}

export default ProviderSearchLink
